import { useCallback } from 'react';
import { usePrompt } from './usePrompt';

/**
 * ERP-themed replacement for window.confirm(): `if (!(await confirm('Delete X?'))) return;`
 * The question up to the first "?" becomes the title, the rest the message;
 * destructive wording (delete / remove / discard / clear) gets a red button.
 */
export function useConfirm() {
  const ask = usePrompt();
  return useCallback(
    async (text: string): Promise<boolean> => {
      const q = text.indexOf('?');
      const short = q > 0 && q <= 90;
      const title = short ? text.slice(0, q + 1) : 'Please confirm';
      const message = (short ? text.slice(q + 1) : text).trim() || undefined;
      const verb = text.match(/\b(delete|remove|discard|clear)\b/i)?.[1];
      return (
        (await ask({
          title,
          message,
          input: false,
          tone: verb ? 'danger' : 'primary',
          confirmLabel: verb ? verb[0].toUpperCase() + verb.slice(1).toLowerCase() : 'Confirm',
        })) !== null
      );
    },
    [ask],
  );
}
